const TOKEN_KEY = 'aidean_token'
const USER_KEY = 'aidean_user'


export function getToken() {
    return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token)
}

export function getUser() {
    const raw = localStorage.getItem(USER_KEY)
    if (!raw) return null
    try {
        return JSON.parse(raw)
    } catch (error) {
        return null
    }
}

export function setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function isLoggedIn() {
    return !!getToken()
}

export function isAdmin() {
    const user = getUser()
    return !!user && !!user.is_admin
}

export function isVip() {
    const user = getUser()
    if (!user) return false
    if (user.is_admin) return true
    if (!user.is_vip) return false
    if (!user.vip_expired_at) return true
    const expiredAt = new Date(user.vip_expired_at)
    return expiredAt.getTime() > Date.now()
}

const ADMIN_TOKEN_KEY = 'aidean_admin_token'
const ADMIN_USER_KEY = 'aidean_admin_user'

export function isImpersonating() {
    return !!localStorage.getItem(ADMIN_TOKEN_KEY)
}

export function startImpersonation(token, user) {
    const currentToken = getToken()
    const currentUser = getUser()
    if (currentToken && currentUser) {
        localStorage.setItem(ADMIN_TOKEN_KEY, currentToken)
        localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(currentUser))
    }
    setToken(token)
    setUser(user)
}

export function stopImpersonation() {
    const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY)
    const adminUserRaw = localStorage.getItem(ADMIN_USER_KEY)
    if (adminToken && adminUserRaw) {
        setToken(adminToken)
        localStorage.setItem(USER_KEY, adminUserRaw)
    }
    localStorage.removeItem(ADMIN_TOKEN_KEY)
    localStorage.removeItem(ADMIN_USER_KEY)
}

export function getVipStatus() {
    const user = getUser()
    if (!user) return { isVip: false, isExpired: false, isPermanent: false, expiredAt: null }
    if (user.is_admin) return { isVip: true, isExpired: false, isPermanent: true, expiredAt: null }
    if (!user.is_vip) return { isVip: false, isExpired: false, isPermanent: false, expiredAt: null }
    if (!user.vip_expired_at) return { isVip: true, isExpired: false, isPermanent: true, expiredAt: null }

    const expiredAt = new Date(user.vip_expired_at)
    const isExpired = expiredAt.getTime() <= Date.now()
    return {
        isVip: !isExpired,
        isExpired: isExpired,
        isPermanent: false,
        expiredAt: user.vip_expired_at
    }
}

export function clearAuth() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
    localStorage.removeItem(ADMIN_TOKEN_KEY)
    localStorage.removeItem(ADMIN_USER_KEY)
}


